define.alias("shared/components/shared/suggestion-text-area", "media/components/shared/suggestion-text-area");